import React, { useContext, useEffect } from "react";
import PagePreview from "./Preview";
import { useSelector } from "react-redux";
import { getData } from "~/functions/gridFunctions";
import PageContainer from "~/components/PageContainer";
import { FullGridContext } from "..";

export default function FinancialSettlementTypes() {
  const filial = useSelector((state) => state.auth.filial);
  const defaultOrderBy = { column: "description", asc: true };
  const defaultGridHeader = [
    {
      title: "Description",
      name: "description",
      type: "text",
      filter: true,
    },
    {
      title: "Status",
      name: "status",
      type: "text",
      filter: true,
    },
    {
      title: "Discount Type",
      name: "discount_type",
      type: "text",
      filter: true,
    },
    {
      title: "Discount Value",
      name: "discount_value",
      type: "number",
      filter: false,
    },
    {
      title: "Payment Method",
      name: "paymentmethod_description",
      type: "text",
      filter: false,
    },
    {
      title: "Filial Name",
      name: "filial_name",
      type: "text",
      filter: true,
    },
  ];

  const {
    accessModule,
    activeFilters,
    gridData,
    gridDetails,
    gridHeader,
    handleFilters,
    handleOpened,
    limit,
    loadingData,
    opened,
    orderBy,
    page,
    pages,
    search,
    setActiveFilters,
    setGridData,
    setGridDetails,
    setGridHeader,
    setLimit,
    setLoadingData,
    setOpened,
    setOrderBy,
    setPage,
    setPages,
    setSearch,
    setTotalRows,
    setSuccessfullyUpdated,
    successfullyUpdated,
    totalRows,
  } = useContext(FullGridContext);

  const pageAccess = accessModule.children.find(
    (el) => el.alias === "settlement_types"
  );

  useEffect(() => {
    setActiveFilters([]);
  }, []);
  async function loader() {
    setLoadingData(true);
    const data = await getData("settlementtypes", {
      limit,
      page,
      orderBy,
      setPages,
      setGridData,
      search,
      defaultGridHeader,
      defaultOrderBy,
      setGridDetails,
    });
    if (!data) {
      return;
    }
    const gridDataValues = data
      .sort((a, b) => a.description > b.description)
      .map(
        (
          {
            id,
            description,
            status,
            discount_type,
            discount_value,
            paymentMethod,
            filial,
          },
          index
        ) => {
          return {
            show: true,
            id,
            fields: [
              description,
              status,
              discount_type,
              discount_value,
              paymentMethod?.description || "",
              filial.name,
            ],
            page: Math.ceil((index + 1) / limit),
          };
        }
      );
    setGridData(gridDataValues);
    setLoadingData(false);
  }

  useEffect(() => {
    loader();
  }, [opened, filial, orderBy, search, limit, page]);

  return (
    <PageContainer
      FullGridContext={FullGridContext}
      PagePreview={PagePreview}
      pageAccess={pageAccess}
      defaultGridHeader={defaultGridHeader}
    />
  );
}
